/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificationCapabilitySpec { 
    /**
     * Enable/ Disable CSP Automatic notifications
     */
    automatic_notification_enabled?: boolean;
    /**
     * Enable/ Disable CSP Manual notifications
     */
    manual_notification_enabled?: boolean;
    /**
     * Enable/ Disable Org Enforcement Email Notification
     */
    enforcement_notification_enabled?: boolean;
    /**
     * Enable/ Disable VMC Host Burst Email Notification
     */
    vmc_burst_notification_enabled?: boolean;
}

